/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select, Input } from 'antd';

const RenameColumnForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Select Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="New Column Name" name="newName" rules={[{ required: true }]}>
            <Input placeholder="Enter new column name" />
        </Form.Item>
    </Form>
);

export default RenameColumnForm;
